import ApplicationSerializer from './application';

export default class InviteSerializer extends ApplicationSerializer {
  attrs = {
    additionalGuestsEnabled: {
      serialize: false,
    },
    approvalStatus: {
      serialize: false,
    },
    editToken: {
      serialize: false,
    },
    employeeScreeningFlow: {
      serialize: false,
    },
    purposeOfVisitName: {
      serialize: false,
    },
    headerText: {
      serialize: false,
    },
    denyMessage: {
      serialize: false,
    },
    photoEnabled: {
      serialize: false,
    },
    thumbnails: {
      serialize: false,
    },
    qrCodeBase64: {
      serialize: false,
    },
  };
}
